module.exports = __webpack_public_path__ + "static/img/kefu_btn.0f954cc4.png";